import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../../Components/helper';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

function MultiSizePackUnits({ data, fromAddEdit, forSwitch, lengthEnabled }) {
  const { t } = useTranslation('common');

  return (
    <Card className="card-margin-bottom rounded-0 pb-3">
      <Card.Header className="bgcolor-dark rounded-0">
        <div className="d-flex flex-wrap align-items-center p-2">
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id="MultiSizeSwitch"
              name="MultiSizeSwitch"
              onChange={forSwitch}
              disabled={!fromAddEdit}
              checked={data?.visible?.multipleTotalPacks}
            />
            <label className="custom-control-label" htmlFor="MultiSizeSwitch">
              <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.MULTI_SIZE_SWITCH')}</strong>
            </label>
          </div>
          <div className="date my-2 my-md-0 pr-3 ml-md-auto">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.HANDOVER_DATE')}
                disable
              />
            </div>
          </div>
          <div className="date justify-content-end pr-1">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MMM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.SHIPMENT_DATE')}
                disable
              />
            </div>
          </div>
        </div>
      </Card.Header>
      {(data?.visible?.multipleTotalPacks || fromAddEdit) && (
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table xs-layout-fixed font-13 mb-3">
              <thead>
                <tr>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.SIZE_COLUMN')}</th>
                  {lengthEnabled && <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.LENGTH_COLUMN')}</th>}
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PACK_RATIO_COLUMN')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.TOTAL_PACKS_COLUMN')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.TOTAL_UNITS_COLUMN')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PRICE_BEFORE_DISCOUNT')} </th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.DISCOUNT_PERCENT')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PRICE_AFTER_DISCOUNT')} </th>
                </tr>
              </thead>
              <tbody>
                <tr key={0}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td rowSpan={3}>
                    <input
                      type="text"
                      name="Total Packs"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td rowSpan={3}>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTOFILLED_TEXT')}</strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.DISCOUNT_PERCENT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PRICE_AFTER_DIS')}
                      className="form-control text-bordered"
                      readOnly
                      disabled
                    />
                  </td>
                </tr>
                <tr key={1}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PERCENT_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PRICE_AFTER_DIS')}
                      className="form-control text-bordered"
                      readOnly
                      disabled
                    />
                  </td>
                </tr>
                <tr key={2}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.DISCOUNT_BEFORE')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PERCENT_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.PRICE_AFTER')}
                      className="form-control text-bordered"
                      readOnly
                      disabled
                    />
                  </td>
                </tr>
                <tr key={3}>
                  <td colSpan={lengthEnabled ? 9 : 8}>
                    <strong className="align-item-center justify-content-center d-flex">
                      {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.TOTAL_TITLE')}
                    </strong>
                  </td>
                </tr>
                <tr key={4}>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTO')}</strong>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTO')}</strong>
                    </td>
                  )}
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTO_')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTO_')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTOS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTOS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SIZE_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      )}
    </Card>
  );
}

export default MultiSizePackUnits;
